import {Component, Input} from '@angular/core';
import { ResizeDetectionService } from '../../../services/resize-detection.service';
import {ProcessStep} from "../../../pages/ng-for-business/ng-for-business.models";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-how-it-works',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss']
})
export class HowItWorksComponent {

  title: any = "How it works";
  steps: any = [
      {
          title: 'Pick Your Perfect Plan',
          description: 'Choose from three different plans to support your wellness goals. Pause, change, or cancel anytime.',
          image: 'assets/images/step_1.webp',
          alt: 'Step 1 - Pick Your Perfect Plan',
      },
      {
          title: 'Our Chefs Get Cooking',
          description: 'Our meals are built by culinary pros and signed off by performance nutritionists.',
          image: 'assets/images/home/step-2-ours-chefs-cooking.jpg',
          alt: 'Step 2 - Our Chefs Get Cooking',
      },
      {
          title: 'Heat, Eat & Enjoy',
          description: 'Your fresh, never-frozen fully prepared meals arrive in an insulated, 100% recyclable packaging. No meal prep, no cleanup, simply heat and enjoy.',
          image: 'assets/images/home/step-3-heat-eat.jpg',
          alt: 'Step 3 - Heat, Eat & Enjoy',
      },
  ];

  trackByStep = (_: number, step: ProcessStep) => step.title;

  constructor() {}

  ngOnInit() {
  }
}
